export default __webpack_public_path__ + "static/media/onhova.8b923440.svg";